module.exports = {
    getOrderStateName: function (stateId) {
        switch (stateId) {
            case 7:
                return 'ПредЧерновик';
            case 1000:
                return 'Черновик';
            case 1:
                return 'Черновик';
            case 2:
                return 'На оформлении';
            case 3:
                return 'Ожидает оплату';
            case 4:
                return 'Ожидает документы';
            case 5:
                return 'Выполнен';
            case 6:
                return 'Архив';
            case 1001:
                return 'Черновик (Offline выборка)';
            case 1002:
                return 'Выполнен (Offline выборка)';
            case 1003:
                return 'Архив (Offline выборка)';
            case 2001:
                return 'Черновик (Offline адр. план)';
            case 2002:
                return 'Выполнен (Offline адр. план)';
            case 2003:
                return 'Архив (Offline адр. план)';
            case 3001:
                return 'Черновик (Индив. выборка)';
            case 3002:
                return 'Ожидает подтверждения (Индив. выборка)';
            case 3003:
                return 'Ожидает оплату (Индив. выборка)';
            case 3004:
                return 'Ожидает документы (Индив. выборка)';
            case 3005:
                return 'Выполнен (Индив. выборка)';
            case 3006:
                return 'Архив (Индив. выборка)';
            default:
                return null;
        }
    }
};




// WEBPACK FOOTER //
// ./helpers/orderStateNameHolder.js